
import { useState, useEffect } from 'react';

export default function LoadingPage() {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress(prev => {
        if (prev >= 100) {
          clearInterval(interval);
          return 100;
        }
        return prev + 2;
      });
    }, 60);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="fixed inset-0 bg-gradient-to-br from-teal-600 via-teal-500 to-cyan-500 flex items-center justify-center z-50">
      <div className="text-center">
        {/* Logo e Título */}
        <div className="mb-8">
          <div className="bg-white rounded-full p-6 mb-6 mx-auto w-24 h-24 flex items-center justify-center shadow-2xl">
            <i className="ri-calculator-line text-4xl text-teal-600"></i>
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-2">
            CalculaDP
          </h1>
          <p className="text-white/80 text-lg">
            Sistema de Cálculos Trabalhistas
          </p>
        </div>

        {/* Barra de Progresso */}
        <div className="w-80 mx-auto mb-6">
          <div className="bg-white/20 rounded-full h-3 overflow-hidden">
            <div 
              className="bg-white h-full rounded-full transition-all duration-300 ease-out"
              style={{ width: `${progress}%` }}
            ></div>
          </div>
          <p className="text-white/90 text-sm mt-2">{progress}%</p>
        </div>

        {/* Texto de carregamento */}
        <div className="text-white/80">
          <p className="text-lg mb-4">Carregando sistema...</p>
          <div className="flex items-center justify-center gap-2">
            <div className="w-2 h-2 bg-white rounded-full animate-bounce"></div>
            <div className="w-2 h-2 bg-white rounded-full animate-bounce" style={{ animationDelay: '0.1s' }}></div>
            <div className="w-2 h-2 bg-white rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
          </div>
        </div>

        {/* Recursos em destaque */}
        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6 max-w-2xl mx-auto">
          <div className="text-center">
            <div className="bg-white/10 rounded-lg p-4 mb-2">
              <i className="ri-time-line text-2xl text-white"></i>
            </div>
            <p className="text-white/80 text-sm">Cálculos em minutos</p>
          </div>
          <div className="text-center">
            <div className="bg-white/10 rounded-lg p-4 mb-2">
              <i className="ri-shield-check-line text-2xl text-white"></i>
            </div>
            <p className="text-white/80 text-sm">100% Precisão</p>
          </div>
          <div className="text-center">
            <div className="bg-white/10 rounded-lg p-4 mb-2">
              <i className="ri-file-pdf-line text-2xl text-white"></i>
            </div>
            <p className="text-white/80 text-sm">Relatórios em PDF</p>
          </div>
        </div>
      </div>
    </div>
  );
}
